import { Component, OnInit, Input} from '@angular/core';
import { PartnerRelationship } from '../models/PartnerRelationship';
import { PartnerService } from '../partner-service';
import { GlobalNamespace as _GlobalNS } from '../../../environments/environment';


@Component({
  selector: 'app-manage-partner-user',
  templateUrl: './manage-partner-user.component.html',
  styleUrls: ['./manage-partner-user.component.scss']
})
export class ManagePartnerUserComponent implements OnInit {
  @Input() relationship: PartnerRelationship;
  managePartnerUri: string;

  constructor(public partnerService: PartnerService) { }

  ngOnInit() {
    this.managePartnerUri = (<any>_GlobalNS).routes.person.ManagePartner;
  }

  showAddDialog() {

  }
}
